import { EllipsisVertical } from 'lucide-react'

import { Button, type ButtonProps } from '~/components/component-library'
import { cn } from '~/utils/tailwind-utils'

export const TABLE_ACTION_COLUMN_WIDTH = {
  size: 58,
  minSize: 58,
  maxSize: 58,
} as const

export const TABLE_ACTION_COLUMN_META = {
  align: 'right',
  isActionColumn: true,
  cellClassName: cn(
    'sticky right-0 z-[1] !py-0.5 !pl-1.5 !pr-4',
    'bg-white group-hover:bg-gray-50 transition-colors',
    'dark:bg-black dark:group-hover:bg-gray-800',
  ),
} as const

export const TableActionTrigger = ({
  'aria-label': ariaLabel = 'Row actions',
  className,
  ...props
}: Omit<ButtonProps, 'variant' | 'size' | 'type'> & {
  'aria-label'?: string
}) => (
  <Button
    {...props}
    type="button"
    variant="tertiary"
    size="small"
    aria-label={ariaLabel}
    className={cn('dark:hover:bg-white/5', className)}
  >
    <EllipsisVertical size={16} />
  </Button>
)
